import template from './workbenchTabsMobile.html';
import WorkbenchTabsCtrl from '../workbenchTabs/workbenchTabsCtrl';
import '../style.scss';

export default {
  template,
  bindings: {
    loanId: '<',
    familyId: '<',
    familyList: '<',
    clientsList: '<',
    workbenchView: '<',
    onViewChange: '&',
    onEmailEdit: '&',
    onMailEdit: '&',
    onNoteEdit: '&',
    onRefreshLog: '&',
    logList: '=',
    isMobile: '<',
  },
  controller: WorkbenchTabsCtrl,
  controllerAs: 'vm',
};
